import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AdminComponent } from './layouts/admin/admin.component';
import { TitleComponent } from './layouts/admin/title/title.component';
import { BreadcrumbsComponent } from './layouts/admin/breadcrumbs/breadcrumbs.component';
import { AuthComponent } from './layouts/auth/auth.component';
import {SharedModule} from './shared/shared.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {MenuItems} from './services/menuitem.service';
import {DemoMaterialModule} from './material-module';


// firebase services and environment module
// import { environment } from '../environments/environment';
//  import { AngularFireModule } from '@angular/fire';
//  import { AngularFireAuthModule } from '@angular/fire/auth';
//  import { AngularFirestoreModule } from '@angular/fire/firestore';

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    TitleComponent,
    BreadcrumbsComponent,
    AuthComponent,

  //  AngularFireModule.initializeApp(environment.firebase)
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    RouterModule,
    DemoMaterialModule,
    HttpClientModule,
  ],
  providers: [MenuItems],
  bootstrap: [AppComponent]
})
export class AppModule { }
